/* eslint-disable */
import React from 'react';
import * as MUI from '@material-ui/core';
import { createStyles } from "@material-ui/styles";
import { Theme, makeStyles } from "@material-ui/core";
import { MultiplicityType, MultiValueParameter, SingleValueParameter } from '@sa/rep-core';
import { ReactReportContext } from '@sa/rep-react';
import { DataType } from '@sa/rep-common';
import { delay } from 'lodash';
import { openHistoryReport } from '../../shared';
import { historyReportsService } from '../../dataFlow';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      height: '100%',
      width: '100%',
      display: "flex",
      flexShrink: 0,
      flexDirection: 'column',
      flex: "none",
      boxSizing: 'border-box',
      background: theme.palette.common.white
    },
  }));

export type Props = { children: any };

export function ReportContainer(props: Props) {
  const classes = useStyles(props);
  const context = React.useContext(ReactReportContext);

  React.useEffect(() => {
    const dataFlow = context.reportContext.dataFlowService;
    window["setParameterValue"] = async function (parameterId: string, type: MultiplicityType, value: any) {
      console.log('set parameter', parameterId, type, value);
      const param = dataFlow.getParameter(parameterId);
      if (param) {
        if (type === MultiplicityType.Multiple) {
          const multiParam = param as MultiValueParameter;
          switch (multiParam.dataType) {
            case DataType.Number:
              multiParam.value = value && (value as unknown[]).map(Number);
              break;
            case DataType.Text:
              multiParam.value = value && (value as unknown[]).map(String);
              break;
            default:
              multiParam.value = value && (value as unknown[]);
              break;
          }
        } else {
          const singleParam = param as SingleValueParameter;
          switch (singleParam.dataType) {
            case DataType.Integer:
            case DataType.Decimal:
            case DataType.Number:
              singleParam.value = value && Number(value);
              break;
            case DataType.Text:
              singleParam.value = value && String(value);
              break;
            default:
              singleParam.value = value;
              break;
          }
        }
      }
    };

    window["loadReport"] = function () {
      console.log('load report');
      const checkInterval = 1000;
      const limitAttempts = 30;
      const limitTime = limitAttempts * checkInterval;
      return new Promise(resolve => {
        const checkExportReady = setInterval(() => {
          console.log('check export ready');
          if (window["exportReady"] === true) {
            console.log('export ready');
            clearInterval(checkExportReady);
            resolve(undefined);
          }
        }, checkInterval);

        setTimeout(() => {
          clearInterval(checkExportReady);
          console.log('break report loading');
          resolve(undefined);
        }, limitTime);
      });
    };
  }, []);

  return (<>
    <MUI.Box className={classes.root}>
      {props.children}
    </MUI.Box>
  </>);
}
